/**
 * Элемент списка.
 * @typedef {Object} ListItem
 * @property {String} id Идентификатор.
 * @property {String} [text] Текстовое представление.
 * @property {Object} [additional] Дополнительные поля.
 */

/**
 * Ключевые поля модели.
 * @type {Array.<String>}
 * @private
 */
const MODEL_CORE_FIELDS = ['id', 'text', 'additional'];

/**
 * Проверка валидности ID.
 * @param {*} id
 * @returns {Boolean}
 */
function _isValidId(id) {
    return typeof id === 'string';
}

/**
 * Проверка ID.
 * @param {*} id
 * @throws {Error} При передаче невалидного ID выдаёт ошибку.
 */
function _validateId(id) {
    if (!_isValidId(id)) {
        throw new Error(`Invalid ID: "${id.toString()}"`);
    }
}

/**
 * Возвращает новую модель с ключевыми полями, скопированными из объекта.
 * Поле `additional` копируется по ссылке. Все остальные поля,
 * включая `parent` и `items`, игнорируется.
 * @throws {Error} Кидает ошибку, если ID модели невалиден.
 * @param {Object} attrs
 * @returns {ListItem}
 */
function from(attrs) {
    _validateId(attrs.id);
    const model = {};
    MODEL_CORE_FIELDS.forEach((fieldName) => {
        if (attrs.hasOwnProperty(fieldName)) {
            model[fieldName] = attrs[fieldName];
        }
    });
    return model;
}

export default {
    from,
};
